import { Heading } from '@backend/lib-design-system';
import type { FC } from 'react';
import { styled } from 'styled-components';

import { useTranslation } from '~/hooks';

interface MissionsCounterProps {
  count: number;
}

const CountMissionTypo = styled(Heading)`
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  font-size: 1rem;
`;

export const MissionListCounter: FC<MissionsCounterProps> = ({ count }) => {
  const t = useTranslation();

  return (
    <CountMissionTypo id="missions_count" variant="heading-4">
      {t('welcome_page.missions_available', { count })}
    </CountMissionTypo>
  );
};
